import CoreBase from '../../services/engines/CoreBase';
import userSettingsService from '../../services/UserSettingsService';
import responseHelper from '../../services/ResponseHelper';

const _name = 'UserSettingsFetcher';

class UserSettingsFetcher extends CoreBase {
    fetch = async () => {
        try {
            const resp = await userSettingsService.getUserSettings();
            const code = responseHelper.check(resp, 'getUserSettings', _name);
            if (code !== 200) return null;

            return resp.data.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const userSettingsFetcher = new UserSettingsFetcher();
export default userSettingsFetcher;
